import { render, staticRenderFns } from "./agreement-dialog.vue?vue&type=template&id=20e3aeda&scoped=true"
import script from "./agreement-dialog.vue?vue&type=script&lang=js"
export * from "./agreement-dialog.vue?vue&type=script&lang=js"
import style0 from "./agreement-dialog.vue?vue&type=style&index=0&id=20e3aeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3aeda",
  null
  
)

export default component.exports